// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"78518":"03390bfefd5bd46d","92888":"1527bc1a0a8f22cb"}[chunkId] + ".css";
};